export const CONFIG_RELOAD = 'CONFIG_RELOAD';
export const CONFIG_UPDATE = 'CONFIG_UPDATE';
